import type { FallbackRender } from '@sentry/react'

import { MdInfoOutline } from 'react-icons/md'
import { useRouteError } from 'react-router-dom'

interface ErrorBoundaryProps {
  message?: string
}

export function ErrorBoundary ({ message }: ErrorBoundaryProps): JSX.Element {
  let error = useRouteError()

  // Do something with the error
  void error

  return (
    <ErrorBoundaryFallback
      message={message}
    />
  )
}

type ErrorBoundaryFallbackProps = Partial<Parameters<FallbackRender>['0']> & {
  message?: string
}

export function ErrorBoundaryFallback (props: ErrorBoundaryFallbackProps): JSX.Element {
  return (
    <div className='tailwind'>
      <div
        className='w-[100vw] h-[100vh] pt-52 flex flex-col justify-start items-center min-h-screen bg-white text-white font-sans font-normal text-base p-8'
      >
        <MdInfoOutline
          color='#BFBFBF'
          className='w-20 h-20'
        />
        <div className='pt-8 pb-7 text-center'>
          <h1 className='text-3xl text-[#666666] tracking-wide pb-4'>
            {props.message ?? 'Something went wrong'}
          </h1>

          <p className='text-[#1E1E1E] text-[1.1rem] tracking-normal'>Please refresh and try again or{' '}
            <button
              className='underline'
              onClick={() => window.location.replace('/')}
            >
              return to the dashboard
            </button>
          </p>
        </div>
        <button
          type='button'
          className='uppercase px-6 py-2 bg-[#0065FF] text-white rounded-sm font-semibold'
          onClick={() => {
            window.location.reload()
          }}
        >
          refresh
        </button>
      </div>
    </div>
  )
}
